import React, { useState, useEffect } from 'react';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import Modal from '../../../../common/components/Modal/modal';
import { delPartnerInBusinessIncome } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import PopUp from '../../../../common/components/PopUp/PopUp';

const ViewPartner = ({ each, setState, setStateData, handleGetPartners }) => {
  return (
    <div className="w-full">
      <div className="font-roboto font-medium text-base text-black-850 my-4  ">
        List of Partners
        <button
          className="rounded bg-orange-650 font-roboto font-normal bg-opacity-50 text-center px-4 py-2 flex text-orange-600 text-sm items-center float-right"
          onClick={e => {
            setState('addPartner'), setStateData(false);
          }}
        >
          <ControlPointOutlinedIcon
            style={{
              color: '#FF8000',
              fontSize: '15px',
              marginLeft: '3px',
              marginRight: '3px'
            }}
          />{' '}
          Add Partner
        </button>
      </div>
      <div className="w-full flex flex-wrap">
        {each.map((every, index) => (
          <PartnerDetails
            every={every}
            key={index}
            setStateData={setStateData}
            setState={setState}
            handleGetPartners={handleGetPartners}
          />
        ))}
      </div>

      <div className="w-full">
        <button
          type="submit"
          className="submitButton font-roboto text-white text-base w-48 mb-10"
        >
          NEXT
        </button>
      </div>
    </div>
  );
};

export default ViewPartner;

const PartnerDetails = ({
  every,
  setStateData,
  setState,
  handleGetPartners
}) => {
  const [showMore, setMore] = useState(false);
  const subheader = 'text-grey-1003 font-roboto font-normal  mr-auto text-xs';
  const accountData = 'text-black-400 font-roboto font-bold  text-sm mr-auto';

  return (
    <div className="w-full block bg-grey-200 rounded-md  max-w-xs my-3 shadow-md pl-1  bg-orange-200  mr-4 ">
      <div className="w-full py-1 px-3 bg-navy-800">
        <div className="float-right">
          <div
            className="cursor-pointer text-right"
            onClick={e => setMore(!showMore)}
          >
            <MoreHorizOutlinedIcon />
          </div>
          {showMore ? (
            <MoreOption
              setStateData={setStateData}
              setState={setState}
              every={every}
              handleGetPartners={handleGetPartners}
            />
          ) : null}
        </div>
        <div className="w-full flex flex-wrap pb-3">
          <div className="block w-6/12 text-left">
            <p className={`${subheader}`}>Director Name</p>
            <p className={`${accountData}`}>{every.name}</p>
          </div>
          <div className=" text-left  text-center w-6/12">
            <p className={`${subheader}`}>PAN Card Number</p>
            <p className={`${accountData}`}>{every.pan}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const MoreOption = ({ setStateData, setState, every, handleGetPartners }) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  const [askConfirmation, setConfirmatkion] = useState(false);
  const handleDelete = () => {
    setConfirmatkion(true);
  };
  const handleDeleteAccount = () => {
    setType('loading');
    setText('deleting Partner please wait...');
    setShow(true);
    delPartnerInBusinessIncome(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      every.partnerId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setConfirmatkion(false);
        setType('success');
        setText('Deleted Partner!');
        setShow(false);
        handleGetPartners();
      })
      .catch(error => {
        setType('fail');
        setText(error?.response?.data?.message || 'somethig went wrong');
        setShow(true);
      });
  };
  return (
    <div
      className="bg-white rounded shadow block absolute ml-8 px-4 py-1 items-center right-3"
      style={{ marginLeft: '-75px' }}
    >
      <div
        className="flex my-1 cursor-pointer font-roboto font-normal text-black-400 trext-xs"
        onClick={e => {
          setState('addPartner');
          setStateData(every);
        }}
      >
        <EditOutlinedIcon
          style={{
            fontSize: '20px',
            marginLeft: '3px',
            marginRight: '3px',
            color: '#545454'
          }}
        />{' '}
        Edit
      </div>
      <div
        className="flex my-1 cursor-pointer font-roboto font-normal text-black-400 trext-xs"
        onClick={handleDelete}
      >
        <DeleteForeverRoundedIcon
          style={{
            fontSize: '20px',
            marginLeft: '3px',
            marginRight: '3px',
            color: '#545454'
          }}
        />{' '}
        Delete
      </div>
      <Modal
        show={askConfirmation}
        setShow={setConfirmatkion}
        noCloseBtn={false}
      >
        <div className="">
          <div className="w-full text-center">
            <p className="font-roboto font-normal tex-black-0 text-center">
              Are you sure?.. You want to delete this Partner?
            </p>
          </div>
          <div className="w-full flex mt-8">
            <button
              type="button"
              className="bg-red-100 text-white px-3 py-2 border border-balck-500 rounded-md font-roboto font-normal"
              onClick={handleDeleteAccount}
            >
              Yes I want To Delete the Partner.
            </button>
            <button
              type="button"
              className="ml-auto  border border-balck-500 rounded font-roboto font-normal px-3 py-2"
              onClick={() => setConfirmatkion(false)}
            >
              Cancle
            </button>
          </div>
        </div>
      </Modal>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};
